import React from "react"

import styled from "styled-components/native"

import Text from "./text"
import { useTokens } from "./tokens-provider"
import Touchable from "./touchable"

const PillContainer = styled(Touchable)<{ selected: boolean }>`
  background: ${({ theme, selected }) =>
    `${selected ? theme.button.backgroundColor.primary : theme.button.backgroundColor.secondary}`};
  border-radius: ${({ theme }) => theme.borderRadius.roundedFull}px;
  padding: ${({ theme }) => `${theme.spacing.tiny}px ${theme.spacing.small}px`};
`

export function Pill<T>({
  id,
  selected,
  value,
  children,
  onPress,
}: {
  id: string
  selected: boolean
  value: T
  children: React.ReactNode
  onPress: (value: T) => void
}) {
  const { tokens } = useTokens()
  return (
    <PillContainer id={id} selected={selected} onPress={() => onPress?.(value)}>
      <Text
        textStyle="strong"
        color={
          selected ? tokens.button.color.primary : tokens.button.color.secondary
        }
      >
        {children}
      </Text>
    </PillContainer>
  )
}
